var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLogoWikimedia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.0051C20 16.4205 16.4183 20 12 20C7.58172 20 4 16.4205 4 12.0051C4 9.61237 5.05175 7.46517 6.71842 6L8.26559 7.54617C6.9918 8.61277 6.18182 10.2144 6.18182 12.0051C6.18182 15.2163 8.78671 17.8196 12 17.8196C15.2133 17.8196 17.8182 15.2163 17.8182 12.0051C17.8182 10.2144 17.0082 8.61277 15.7344 7.54617L17.2816 6C18.9483 7.46517 20 9.61237 20 12.0051Z",
    fill: "#006699"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5245 9.00001C8.59601 9.72353 8 10.8448 8 12.1037C8 14.0614 9.44152 15.6865 11.3333 16V10.7866L9.5245 9.00001Z",
    fill: "#339966"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 16C14.5585 15.6865 16 14.0614 16 12.1037C16 10.8448 15.404 9.72352 14.4755 9L12.6667 10.7866V16Z",
    fill: "#339966"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 2,
    fill: "#990000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLogoWikimedia);
export default __webpack_public_path__ + "static/media/ic_action_logo_wikimedia.c67ab17445f9ad54048e88bfff07c477.svg";
export { ForwardRef as ReactComponent };